module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-vi-VN.d3ab8274.jpg";